import { FCX } from "@datassential/platform-ui-lib";
import cn from "classnames";
import { IconDsLogoNewSmall } from "@icons";

const HomeSectionDelimiter: FCX<{
    colors?: string[];
    noLogo?: boolean;
}> = ({
    colors = [],
    noLogo = false,
    className,
    style,
    testId,
}) => {
    return (
        <div
            className={cn(
                "HomeSection__delimiter",
                className,
                !noLogo && 'has-logo',
            )}
            style={{
                ...style,
                backgroundImage: `linear-gradient(to right, ${colors.join(', ')})`,
            }}
            data-testid={testId}
        >
            {!noLogo && (
                <IconDsLogoNewSmall className="HomeSection__delimiter-logo"/>
            )}
        </div>
    );
}

export default HomeSectionDelimiter;